var _path, _g, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarningRoundedOutlined(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1836_4907",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 17,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.16797 2.5H18.8461V17.6546H2.16797V2.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1836_4907)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5121 3.75C10.1155 3.75 9.76215 3.955 9.56381 4.29917L3.56548 14.77C3.37048 15.1117 3.37215 15.5192 3.56965 15.86C3.76715 16.2008 4.12048 16.405 4.51465 16.405H16.5005C16.8938 16.405 17.2471 16.2008 17.4446 15.86C17.643 15.5192 17.6446 15.1117 17.448 14.77L11.4605 4.29917C11.263 3.955 10.9096 3.75 10.5121 3.75ZM16.5005 17.655H4.51465C3.66965 17.655 2.91215 17.2183 2.48798 16.4867C2.06381 15.7558 2.06131 14.8817 2.48048 14.1492L8.48048 3.6775C8.90215 2.94 9.66131 2.5 10.5121 2.5H10.513C11.363 2.5 12.1238 2.94083 12.5455 3.67917L18.5338 14.1492C18.953 14.8817 18.9505 15.7558 18.5263 16.4867C18.1021 17.2183 17.3446 17.655 16.5005 17.655Z",
    fill: "current"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5039 11.8033C10.1589 11.8033 9.87891 11.5233 9.87891 11.1783V8.595C9.87891 8.25 10.1589 7.97 10.5039 7.97C10.8489 7.97 11.1289 8.25 11.1289 8.595V11.1783C11.1289 11.5233 10.8489 11.8033 10.5039 11.8033Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5055 14.5825C10.0446 14.5825 9.66797 14.21 9.66797 13.7492C9.66797 13.2883 10.0371 12.9158 10.4971 12.9158H10.5055C10.9663 12.9158 11.3388 13.2883 11.3388 13.7492C11.3388 14.21 10.9663 14.5825 10.5055 14.5825Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningRoundedOutlined);
export default __webpack_public_path__ + "static/media/warning_rounded_outlined.adb1e7a1.svg";
export { ForwardRef as ReactComponent };